<template>
  <div class="p-postEditor__itemWrapper p-textItem__editorWrap">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <TextItemPreview :item="item" />
    </div>
    <item-form
      v-if="editingItemIndex === index"
      :item="item"
      @cancel="resetText"
      @savetext="saveText"
    >
      <div
        :id="editorId"
        class="body-2 mt-5 editableArea p-textItem__editor"
        v-html="defaultTextContent"
      />
      <div class="d-flex justify-space-between pr-2">
        <div class="caption">shift+enterで改行</div>
        <div class="caption">{{ textWordsCount }} 文字</div>
      </div>
    </item-form>
  </div>
</template>

<script>
import MediumEditor from 'medium-editor'
import itemUtilsMixin from '@/mixins/item_utils'
import TextItemPreview from './previews/TextItemPreview'
import ItemForm from './ItemForm'

export default {
  name: 'TextItem',
  components: { TextItemPreview, ItemForm },
  mixins: [itemUtilsMixin],
  data () {
    return {
      editorId: `text_editor_${this.item.uuid}`,
      editor: null,
      oldText: '',
      editText: ''
    }
  },
  computed: {
    defaultTextContent () {
      return this.item.itemableAttributes.content
    },
    textWordsCount: function () {
      const resetText = this.editText.replace(/(<([^>]+)>)/gi, '')
      return resetText.replace(/(&nbsp;)/gi, ' ').length
    }
  },
  created () {
    this.oldText = this.item.itemableAttributes.content
    this.editText = this.item.itemableAttributes.content
  },
  mounted () {
    this.initializeEditor()
  },
  updated () {
    this.initializeEditor()
  },
  methods: {
    initializeEditor () {
      const element = document.getElementById(this.editorId)
      this.editor = this.setupEditor(element)
      this.editor.subscribe('editableInput', () => {
        this.editText = element.innerHTML.replace(/(<([^>]+)>)/gi, '')
          ? element.innerHTML
          : ''

        this.updateEditingItemable(this.editText, 'content')
      })
      if (element) {
        element.focus()
      }
      // シフトエンター以外のエンターを許容しない
      this.editor.subscribe('editableKeydownEnter', (event) => {
        if (!event.shiftKey) {
          event.preventDefault()
          event.stopPropagation()
        }
      })
    },
    setupEditor (targetElement) {
      return new MediumEditor(targetElement, {
        targetBlank: true,
        toolbar: {
          buttons: ['bold', 'italic', 'underline', 'anchor'],
          diffLeft: 0,
          diffTop: -10,
          firstButtonClass: 'medium-editor-button-first',
          lastButtonClass: 'medium-editor-button-last',
          relativeContainer: null,
          standardizeSelectionStart: false,
          static: false,
          align: 'left'
        },
        placeholder: {
          text: ''
        },
        anchor: {
          customClassOption: null,
          customClassOptionText: 'Button',
          linkValidation: false,
          placeholderText: 'https://example.co.jp'
        },
        paste: {
          cleanPastedHTML: true,
          doPaste (pastedHTML, pastedPlain) {
            if (pastedPlain) {
              MediumEditor.util.insertHTMLCommand(
                this.document,
                pastedPlain.replace(/\r\n|\r|\n/g, '<br>')
              )
            }
          }
        }
      })
    },
    resetText () {
      this.updateEditingItemable(this.oldText, 'content')
    },
    saveText () {
      this.editText = this.editText.replace(/ style="font-size: 0.875rem; letter-spacing: 0.0178571em;"/g, '').replace(/<span>|<\/span>/g, '')
      this.updateEditingItemable(this.editText, 'content')
    }
  }
}
</script>

<style>
@import './css/medium-editor.css';
@import './css/themes/default.css';

.v-application p {
  margin-bottom: 0 !important;
}

.p-textItem__editorWrap i {
  font-style: italic;
}

.editableArea {
  border-bottom: solid 1px grey;
}

.editableArea:hover {
  border-bottom: solid 1px black;
}

.editableArea:focus {
  outline: none;
  border-bottom: solid 2px #039be5;
}
</style>
